
import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Grid, CardMedia, CardContent, Card, Typography } from '@mui/material';
import useImageUriGenerator from './ImgUriGenerator';
import GuideCard from './GuideCardV2';
import useImageUris from './useImageUris';

const GuidesCatalogue = ({ guides }) => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 960);
    };

    handleResize();

    window.addEventListener('resize', handleResize);


    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const truncationLength = 100;
  const guidesRef = useRef(null);
  const tooRef = useRef(null);
  const [activeTab, setActiveTab] = useState('Guides');

  const handleGuidesClick = () => {
    setActiveTab('Guides');
  };

  const handleToolsClick = () => {
    setActiveTab('Tools');
    const offset = 30; // Adjust the offset value as needed
    const topOffsetPosition = tooRef.current.offsetTop - offset;
    window.scrollTo({ top: topOffsetPosition, behavior: 'smooth' });
  };

  const imageUris = useImageUris(guides);
  return (
    <Grid Container sx={12} marginRight={isMobile ? 2 : 24}>
      <Box display="flex" alignItems="center">
        <Typography variant="h2" gutterBottom sx={{ fontFamily: 'Inter', fontWeight: 700, fontSize: isMobile ? '32px' : '24px', lineHeight: '48px' }}>
          <Link
            to="#"
            onClick={handleGuidesClick}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              borderBottom: activeTab === 'Guides' ? '4px solid #31B9B5' : 'none',
              paddingBottom: '5px',
              cursor: 'pointer',
            }}
          >
            Guides
          </Link>
        </Typography>
        <Typography variant="h5" gutterBottom sx={{ fontFamily: 'Inter', fontWeight: 700, fontSize: isMobile ? '32px' : '24px', lineHeight: '48px', marginLeft: '20px' }}>
          <Link
            to="#"
            onClick={handleToolsClick}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              borderBottom: activeTab === 'Tools' ? '4px solid #31B9B5' : 'none',
              paddingBottom: '5px',
              pointerEvents: activeTab === 'Tools' ? 'none' : 'auto',
              cursor: 'pointer', // Add cursor style
            }}
          >
            Tools
          </Link>
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {guides.map((guide) => {
          const truncatedDescription = guide.description.slice(0, truncationLength) + (guide.description.length > truncationLength ? '...' : '');
          const imagePath = `./thumbnail/${guide.img}.png`;
          const imageDataURI = imageUris[guide.id];
          return (
            <Grid item key={guide.id} xs={12} sm={6} md={4}>
              <GuideCard guide={guide} imageDataURI={imagePath} />
            </Grid>
          );
        })}
      </Grid>
      <div ref={guidesRef}>
        {/* Content for the "Guides" section */}
        <h2></h2>
        {/* Add your content for the "Guides" section here */}
      </div>
      <div ref={tooRef}>
        {/* Content for the "Tools" section */}
        <h2></h2>
        {/* Add your content for the "Tools" section here */}
      </div>
    </Grid>
  );
};

export default GuidesCatalogue;
